import { Component, OnInit, OnDestroy } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { BroadcastService } from '@azure/msal-angular';
import { LoginAwareComponent } from '../login-aware-component';
import { DiagnosticsServiceFactory } from '../services/diagnostics-service-factory';

/**
 * Initiates authentication sequence. All the hard work is done by MSAL
 * (Microsoft Authentication Library) for Angular, or its mock when working in isolation
 * from Office 365/Azure.
 */
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends LoginAwareComponent implements OnInit, OnDestroy {

  constructor(
    diagnosticsFactory: DiagnosticsServiceFactory,
    broadcastService: BroadcastService,
    authService: MsalService) {
    super(diagnosticsFactory.create('LoginComponent'), broadcastService, authService);
  }

  protected onLoginFailure (payload: any) {
    this.handleLoginFailure(payload);
  }

  public login() {
    this.authService.loginPopup();
  }

  public logout() {
    this.authService.logout();
  }
}
